import { render, staticRenderFns } from "./Swipper.vue?vue&type=template&id=dec58b5a&scoped=true&"
import script from "./Swipper.vue?vue&type=script&lang=js&"
export * from "./Swipper.vue?vue&type=script&lang=js&"
import style0 from "./Swipper.vue?vue&type=style&index=0&id=dec58b5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec58b5a",
  null
  
)

export default component.exports